module.exports = __webpack_public_path__ + "images/blue-arrow-left.svg";